import client from '@/shared/apis/client'

export interface TextReplacementRule {
  id: string
  target_text: string
  replacement_text: string
  description?: string
  created_at: string
  updated_at: string
}

export interface CreateTextReplacementRequest {
  target_text: string
  replacement_text: string
  description?: string
}

export interface UpdateTextReplacementRequest {
  target_text?: string
  replacement_text?: string
  description?: string
}

// ルール一覧取得
export const getTextReplacements = async (): Promise<TextReplacementRule[]> => {
  const response = await client.get<{
    count: number
    results: TextReplacementRule[]
  }>('/api/text-replacements/')
  return response.data.results
}

// ルール作成
export const createTextReplacement = async (
  data: CreateTextReplacementRequest
): Promise<TextReplacementRule> => {
  const response = await client.post('/api/text-replacements/', data)
  return response.data
}

// ルール詳細取得
export const getTextReplacementById = async (
  id: string
): Promise<TextReplacementRule> => {
  const response = await client.get(`/api/text-replacements/${id}/`)
  return response.data
}

// ルール更新（全項目）
export const updateTextReplacement = async (
  id: string,
  data: CreateTextReplacementRequest
): Promise<TextReplacementRule> => {
  const response = await client.put(`/api/text-replacements/${id}/`, data)
  return response.data
}

// ルール部分更新
export const patchTextReplacement = async (
  id: string,
  data: UpdateTextReplacementRequest
): Promise<TextReplacementRule> => {
  const response = await client.patch(`/api/text-replacements/${id}/`, data)
  return response.data
}

// ルール削除
export const deleteTextReplacement = async (id: string): Promise<void> => {
  await client.delete(`/api/text-replacements/${id}/`)
}
